module.exports = __webpack_public_path__ + "eb6883f05524237a3b99850f34dc4e99.fbx";